// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import StageHeaderController from "./stage_header_controller"
application.register("stage-header", StageHeaderController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import SessionLoaderController from "./session_loader_controller"
application.register("session-loader", SessionLoaderController)

import AutoplayVideoController from "./autoplay_video_controller"
application.register("autoplay-video", AutoplayVideoController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BackNavController from "./back_nav_controller"
application.register("back-nav", BackNavController)

import BookmarkManagerController from "./bookmark_manager_controller"
application.register("bookmark-manager", BookmarkManagerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SalesEnquiryController from "./sales_enquiry_controller"
application.register("sales-enquiry", SalesEnquiryController)

import StickyVideoController from "./sticky_video_controller"
application.register("sticky-video", StickyVideoController)

import TableOfContentsController from "./table_of_contents_controller"
application.register("table-of-contents", TableOfContentsController)

import TerminalTitleController from "./terminal_title_controller"
application.register("terminal-title", TerminalTitleController)

import WadTrackingController from "./wad_tracking_controller"
application.register("wad-tracking", WadTrackingController)


import BusinessPricingController from "./business_pricing_controller"
application.register("business-pricing", BusinessPricingController)

import TeamAccessController from "./team_access_controller"
application.register("team-access", TeamAccessController)

// Video preview controllers are registered by the page-only teams_previews entry.

import FormatPreviewsController from "./format_previews_controller"
application.register("format-previews", FormatPreviewsController)

import LiveScheduleLoaderController from "./live_schedule_loader_controller"
application.register("live-schedule-loader", LiveScheduleLoaderController)

import LiveScheduleController from "./live_schedule_controller"
application.register("live-schedule", LiveScheduleController)

import AgentIllustrationController from "./agent_illustration_controller"
application.register("agent-illustration", AgentIllustrationController)

import CloudflareLiveController from "./cloudflare_live_controller"
application.register("cloudflare-live", CloudflareLiveController)
